import React, { useEffect, useState } from 'react';
import axios from 'axios';

// thin bar across the top of the window while any api request is in flight (every v2 call goes through axios)
const TopProgress: React.FC = () => {
    const [pending, setPending] = useState(0);

    useEffect(() => {
        const done = () => setPending(n => Math.max(0, n - 1));
        const req = axios.interceptors.request.use(config => {
            setPending(n => n + 1);
            return config;
        });
        const res = axios.interceptors.response.use(response => {
            done();
            return response;
        }, error => {
            done();
            return Promise.reject(error);
        });
        return () => {
            axios.interceptors.request.eject(req);
            axios.interceptors.response.eject(res);
        };
    }, []);

    return pending > 0 ? <div className="v2-top-progress" role="progressbar" aria-label="Loading"><span /></div> : null;
};

export default TopProgress;
